/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Past_MonthInputs */



/**
* | output |
* | --- |
* | "Past Month" |
*
* @param {Past_MonthInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const past_month = /** @type {((inputs?: Past_MonthInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Past_MonthInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mois passé")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letzter Monat")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mese scorso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прошлый месяц")
	if (locale === "es") return /** @type {LocalizedString} */ ("El mes pasado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("上个月")
	if (locale === "ja") return /** @type {LocalizedString} */ ("先月")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बीते हुए महीने में")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mês passado")
	return /** @type {LocalizedString} */ ("Past Month")
});